import { History } from "history";

import {
  ADD_LESSON,
  ADD_LESSON_ERROR,
  ADD_LESSON_SUCCESS,
  AddLessonAction,
  AddLessonErrorAction,
  AddLessonSuccessAction,
  DELETE_LESSON,
  DELETE_LESSON_CONSENT,
  DELETE_LESSON_ERROR,
  DELETE_LESSON_SUCCESS,
  DeleteLessonAction,
  DeleteLessonConsentAction,
  DeleteLessonErrorAction,
  DeleteLessonSuccessAction,
  GET_LESSON,
  GET_LESSONS,
  GET_LESSONS_ERROR,
  GET_LESSONS_SUCCESS,
  GET_LESSON_ERROR,
  GET_LESSON_SUCCESS,
  GET_LESSON_DETAIL,
  GET_LESSON_DETAIL_ERROR,
  GET_LESSON_DETAIL_SUCCESS,
  GetLessonAction,
  GetLessonErrorAction,
  GetLessonSuccessAction,
  GetLessonsAction,
  GetLessonsErrorAction,
  GetLessonsSuccessAction,
  UPDATE_LESSON,
  UPDATE_LESSON_ERROR,
  UPDATE_LESSON_SUCCESS,
  UpdateLessonAction,
  UpdateLessonErrorAction,
  UpdateLessonSuccessAction,
  GetLessonDetailErrorAction,
  GetLessonDetailAction,
  GetLessonDetailSuccessAction,
  ToggleLessonStateAction,
  ToggleLessonStateConsentAction,
  ToggleLessonStateErrorAction,
  ToggleLessonStateSuccessAction,
  TOGGLE_LESSON_STATE,
  TOGGLE_LESSON_STATE_CONSENT,
  TOGGLE_LESSON_STATE_ERROR,
  TOGGLE_LESSON_STATE_SUCCESS,
  GET_LESSON_LIST_BY_CHAPTER,
  GET_LESSON_LIST_BY_CHAPTER_ERROR,
  GET_LESSON_LIST_BY_CHAPTER_SUCCESS,
  GetLessonSelectListByChapterAction,
  GetLessonSelectListByChapterErrorAction,
  GetLessonSelectListByChapterSuccessAction,
  RESET_LESSON_LIST_BY_CHAPTER,
  ResetLessonSelectListByChapterAction,
} from "./actionTypes";
import {
  CreateLessonRequest,
  LessonDto,
  PaginateQuery,
  UpdateLessonRequest,
} from "../../interfaces";
import { Paginated, SelectListDto } from "../../models";
import {
  TOGGLE_CHAPTER_STATE_CONSENT,
  TOGGLE_CHAPTER_STATE,
  TOGGLE_CHAPTER_STATE_SUCCESS,
  TOGGLE_CHAPTER_STATE_ERROR,
} from "../chapter/actionTypes";

//#region Get Lessons

export const getLessons = (
  request: PaginateQuery,
  history: History
): GetLessonsAction => {
  return {
    type: GET_LESSONS,
    payload: { request, history },
  };
};

export const getLessonsSuccess = (
  response: Paginated<LessonDto>
): GetLessonsSuccessAction => {
  return {
    type: GET_LESSONS_SUCCESS,
    payload: response,
  };
};

export const getLessonsError = (error: any): GetLessonsErrorAction => {
  return {
    type: GET_LESSONS_ERROR,
    payload: error,
  };
};

//#endregion

//#region Get Lesson

export const getLesson = (id: string, history: History): GetLessonAction => {
  return {
    type: GET_LESSON,
    payload: { id, history },
  };
};

export const getLessonSuccess = (
  response: LessonDto
): GetLessonSuccessAction => {
  return {
    type: GET_LESSON_SUCCESS,
    payload: response,
  };
};

export const getLessonError = (error: any): GetLessonDetailErrorAction => {
  return {
    type: GET_LESSON_ERROR,
    payload: error,
  };
};

//#endregion

//#region Get Lesson Detail

export const getLessonDetail = (
  id: string,
  history: History
): GetLessonDetailAction => {
  return {
    type: GET_LESSON_DETAIL,
    payload: { id, history },
  };
};

export const getLessonDetailSuccess = (
  response: LessonDto
): GetLessonDetailSuccessAction => {
  return {
    type: GET_LESSON_DETAIL_SUCCESS,
    payload: response,
  };
};

export const getLessonDetailError = (
  error: any
): GetLessonDetailErrorAction => {
  return {
    type: GET_LESSON_DETAIL_ERROR,
    payload: error,
  };
};

//#endregion

//#region Add Lesson

export const addLesson = (
  request: CreateLessonRequest,
  history: History
): AddLessonAction => {
  return {
    type: ADD_LESSON,
    payload: { request, history },
  };
};

export const addLessonSuccess = (): AddLessonSuccessAction => {
  return {
    type: ADD_LESSON_SUCCESS,
    payload: null,
  };
};

export const addLessonError = (error: any): AddLessonErrorAction => {
  return {
    type: ADD_LESSON_ERROR,
    payload: error,
  };
};

//#endregion

//#region Update Lesson

export const updateLesson = (
  id: string,
  request: UpdateLessonRequest,
  history: History
): UpdateLessonAction => {
  return {
    type: UPDATE_LESSON,
    payload: { id, request, history },
  };
};

export const updateLessonSuccess = (): UpdateLessonSuccessAction => {
  return {
    type: UPDATE_LESSON_SUCCESS,
    payload: null,
  };
};

export const updateLessonError = (error: any): UpdateLessonErrorAction => {
  return {
    type: UPDATE_LESSON_ERROR,
    payload: error,
  };
};

//#endregion

//#region Delete Lesson

export const deleteLessonConsent = (id: string): DeleteLessonConsentAction => {
  return {
    type: DELETE_LESSON_CONSENT,
    payload: id,
  };
};

export const deleteLesson = (
  id: string,
  history: History
): DeleteLessonAction => {
  return {
    type: DELETE_LESSON,
    payload: { id, history },
  };
};

export const deleteLessonSuccess = (): DeleteLessonSuccessAction => {
  return {
    type: DELETE_LESSON_SUCCESS,
    payload: null,
  };
};

export const deleteLessonError = (error: any): DeleteLessonErrorAction => {
  return {
    type: DELETE_LESSON_ERROR,
    payload: error,
  };
};

//#endregion

//#region Toggle Lesson State

export const toggleLessonStateConsent = (
  id: string
): ToggleLessonStateConsentAction => {
  return {
    type: TOGGLE_LESSON_STATE_CONSENT,
    payload: id,
  };
};

export const toggleLessonState = (
  chapterId: string,
  lessonId: string
): ToggleLessonStateAction => {
  return {
    type: TOGGLE_LESSON_STATE,
    payload: { chapterId, lessonId },
  };
};

export const toggleLessonStateSuccess = (
  chapterId: string,
  lessonId: string
): ToggleLessonStateSuccessAction => {
  return {
    type: TOGGLE_LESSON_STATE_SUCCESS,
    payload: { chapterId, lessonId },
  };
};

export const toggleLessonStateError = (
  error: any
): ToggleLessonStateErrorAction => {
  return {
    type: TOGGLE_LESSON_STATE_ERROR,
    payload: error,
  };
};

//#endregion

//#region Get Lesson Select List by Chapter

export const getLessonSelectListByChapter = (
  chapterId: string
): GetLessonSelectListByChapterAction => {
  return {
    type: GET_LESSON_LIST_BY_CHAPTER,
    payload: { chapterId },
  };
};

export const getLessonSelectListByChapterSuccess = (
  response: SelectListDto[]
): GetLessonSelectListByChapterSuccessAction => {
  return {
    type: GET_LESSON_LIST_BY_CHAPTER_SUCCESS,
    payload: response,
  };
};

export const getLessonSelectListByChapterError = (
  error: any
): GetLessonSelectListByChapterErrorAction => {
  return {
    type: GET_LESSON_LIST_BY_CHAPTER_ERROR,
    payload: error,
  };
};

export const resetLessonSelectListByChapter =
  (): ResetLessonSelectListByChapterAction => {
    return {
      type: RESET_LESSON_LIST_BY_CHAPTER,
      payload: {},
    };
  };

//#endregion
